import { render, staticRenderFns } from "./PlanGymnasticsSelPage.vue?vue&type=template&id=c3a1fa40&scoped=true"
import script from "./PlanGymnasticsSelPage.vue?vue&type=script&lang=js"
export * from "./PlanGymnasticsSelPage.vue?vue&type=script&lang=js"
import style0 from "./PlanGymnasticsSelPage.vue?vue&type=style&index=0&id=c3a1fa40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a1fa40",
  null
  
)

export default component.exports